<div class="container">
  <h3>
    {{
      '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.SYSTEM_BEHAVIOR' | translate
    }}
  </h3>
  <ul class="system-characteristics-list">
    <li *ngFor="let systemCharacteristic of systemCharacteristics | htmlExtractor: 'p'">
      {{ systemCharacteristic }}
    </li>
  </ul>
</div>
